import { arrayToThresholds } from "./arrayToThresholds";
import { getClosestValue } from "./getClosestValue";

function getPriorityTagColor(prio: number) {
  let h = 90 - (prio / 100) * 90,
    s = "100%",
    l = "50%";
  return `hsl(${h}, ${s}, ${l})`;
}

function getPriorityLabelByValue(value: number) {
  const threshold = getClosestValue(PRIORITY_THRESHOLDS, value);
  const index = PRIORITY_THRESHOLDS.indexOf(threshold);
  return PRIORITY_LABELS[index];
}

function getPriorityThresholdByValue(value: number) {
  return getClosestValue(PRIORITY_THRESHOLDS, value);
}

const PRIORITY_LABELS = [
  "maintenance:monitor.daily_schedule.overview.prio.verylow",
  "maintenance:monitor.daily_schedule.overview.prio.low",
  "maintenance:monitor.daily_schedule.overview.prio.mid",
  "maintenance:monitor.daily_schedule.overview.prio.high",
  "maintenance:monitor.daily_schedule.overview.prio.ultra",
];

const PRIORITY_THRESHOLDS = arrayToThresholds(PRIORITY_LABELS);

/**
 * Returns all priority helpers and props
 * @param ticketData
 * @returns priority helpers and props
 */
export function getPriorityProps() {
  return {
    thresholds: PRIORITY_THRESHOLDS,
    labels: PRIORITY_LABELS,
    getPriorityLabelByValue,
    getPriorityThresholdByValue,
    getPriorityTagColor,
  };
}
